'use strict';

import './info.css';

import angular from 'angular';

import saInfo from './info.component';
import saInfoAbout from './info_about.component';
import saInfoAdviceForGuide from './info_advice_for_guide.component';
import saInfoBecomeGuide from './info_become_guide.component';
import saInfoBookingAdvice from './info_booking_advice.component';
import saInfoContact from './info_contact.component';
import saInfoMenu from './info_menu.component';
import saInfoPaymentsPricing from './info_payments_pricing.component';
import saInfoPrivacy from './info_privacy.component';
import saInfoRefunds from './info_refunds.component';
import saInfoReviews from './info_reviews.component';
import saInfoSecurity from './info_security.component';
import saInfoTerms from './info_terms.component';
import saInfoTermsAndConditionsGiveaway from './info_terms_and_conditions_giveaway.component';


export default angular
  .module('info', [])
  .directive('saInfo', saInfo)
  .directive('saInfoAbout', saInfoAbout)
  .directive('saInfoAdviceForGuide', saInfoAdviceForGuide)
  .directive('saInfoBecomeGuide', saInfoBecomeGuide)
  .directive('saInfoBookingAdvice', saInfoBookingAdvice)
  .directive('saInfoContact', saInfoContact)
  .directive('saInfoMenu', saInfoMenu)
  .directive('saInfoPaymentsPricing', saInfoPaymentsPricing)
  .directive('saInfoPrivacy', saInfoPrivacy)
  .directive('saInfoRefunds', saInfoRefunds)
  .directive('saInfoReviews', saInfoReviews)
  .directive('saInfoSecurity', saInfoSecurity)
  .directive('saInfoTerms', saInfoTerms)
  .directive('saInfoTermsAndConditionsGiveaway', saInfoTermsAndConditionsGiveaway)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/info/index.js